// extracted by mini-css-extract-plugin
module.exports = {"Faq":"Faq_Faq__eU39J","Faq__title":"Faq_Faq__title__1CmxK","Faq__content":"Faq_Faq__content__2EsYH","Faq__button":"Faq_Faq__button__g535P"};